import React from 'react';
import { FaFacebookF, FaTwitter, FaInstagram, FaYoutube, FaLinkedinIn } from 'react-icons/fa';

import logo from '../../assets/images/logo.png';

const Footer = () => {
  return (
    <footer className="bg-darkblue">
      <div className="container mx-auto lg:px-10 px-8">
        <div className="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-4 gap-6 lg:py-12 py-10">
          <div className="col-span-full lg:col-span-1">
            <div className="lg:max-w-2xl mx-auto">
              <div className="flex items-center lg:justify-start justify-center">
                <img src={logo} alt="Logo" className="h-10 me-5" />
              </div>
              <p className="text-white lg:max-w-xs mt-6 text-sm font-medium leading-7 lg:text-left text-center">
                Lorem ipsum dolor sit amet, consectetur adip, sed do eiusmod tempor incididunt ut labore et dolore magna
                aliqua.
              </p>
            </div>
            <ul className="flex items-center mt-6 gap-4 lg:justify-start justify-center">
              <li className="w-8 h-8 flex items-center justify-center bg-white/10 transition-all duration-500 hover:bg-gold cursor-pointer">
                <a href="#">
                  <FaFacebookF color="white" />
                </a>
              </li>
              <li className="w-8 h-8 flex items-center justify-center bg-white/10 transition-all duration-500 hover:bg-gold cursor-pointer">
                <a href="#">
                  <FaTwitter color="white" />
                </a>
              </li>
              <li className="w-8 h-8 flex items-center justify-center bg-white/10 transition-all duration-500 hover:bg-gold cursor-pointer">
                <a href="#">
                  <FaInstagram color="white" />
                </a>
              </li>
              <li className="w-8 h-8 flex items-center justify-center bg-white/10 transition-all duration-500 hover:bg-gold cursor-pointer">
                <a href="#">
                  <FaYoutube color="white" />
                </a>
              </li>
              <li className="w-8 h-8 flex items-center justify-center bg-white/10 transition-all duration-500 hover:bg-gold cursor-pointer">
                <a href="#">
                  <FaLinkedinIn color="white" />
                </a>
              </li>
            </ul>
          </div>

          <div className="col-span-full lg:col-span-1 lg:px-12 px-0 lg:text-left text-center">
            <h4 className="font-bold text-white uppercase">RESOURCES</h4>
            <div className="mt-6 grid space-y-3">
              <p>
                <a className="inline-flex gap-x-2 text-xs text-white font-medium transition-all duration-300" href="#">
                  Home
                </a>
              </p>
              <p>
                <a className="inline-flex gap-x-2 text-xs text-white font-medium transition-all duration-300" href="#">
                  Services
                </a>
              </p>
              <p>
                <a className="inline-flex gap-x-2 text-xs text-white font-medium transition-all duration-300" href="#">
                  About US
                </a>
              </p>
              <p>
                <a className="inline-flex gap-x-2 text-xs text-white font-medium transition-all duration-300" href="#">
                  Why Choose Us
                </a>
              </p>
              <p>
                <a className="inline-flex gap-x-2 text-xs text-white font-medium transition-all duration-300" href="#">
                  Testimonials
                </a>
              </p>
            </div>
          </div>

          <div className="col-span-full lg:col-span-1 lg:text-left text-center">
            <h4 className="font-bold text-white uppercase">CONTACTS</h4>
            <div className="mt-6 grid space-y-3">
              <a
                className="inline-flex items-center gap-x-4 text-white text-xs font-medium leading-8 transition-all duration-300 lg:justify-start justify-center"
                href="#"
              >
                <svg width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M13 7.50012C13 10.3219 8.68174 14.2217 7.37207 15.3396C7.15659 15.5235 6.84341 15.5235 6.62793 15.3396C5.31826 14.2217 1 10.3219 1 7.50012C1 4.17394 3.68629 1.47754 7 1.47754C10.3137 1.47754 13 4.17394 13 7.50012Z"
                    stroke="#DBB079"
                  />
                  <path
                    d="M8.99981 7.06184C8.99981 8.18005 8.10438 9.08653 6.99981 9.08653C5.89524 9.08653 4.99981 8.18005 4.99981 7.06184C4.99981 5.94364 5.89524 5.03716 6.99981 5.03716C8.10438 5.03716 8.99981 5.94364 8.99981 7.06184Z"
                    stroke="#DBB079"
                  />
                </svg>
                919 Congress, Suite 1425 • Austin, Texas 78701
              </a>

              <a
                className="inline-flex items-center gap-x-4 text-white text-xs font-medium leading-8 transition-all duration-300 lg:justify-start justify-center"
                href="#"
              >
                <svg width="13" height="16" viewBox="0 0 13 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M5.53413 2.45237L5.32244 2.11997C5.17962 1.8954 5.10831 1.78317 5.03519 1.6957C4.4961 1.05088 3.53604 0.823705 2.7046 1.14392C2.59183 1.18735 2.46662 1.25247 2.21598 1.38385C0.855422 2.1695 0.957832 4.85086 1.04536 5.24818C1.04536 5.24818 1.06308 6.56179 3.03645 9.66489C5.00981 12.768 6.46543 13.7716 6.46543 13.7716C7.29355 14.3908 9.30714 15.4602 10.7369 14.7833C11.5348 14.4272 12.797 12.6242 13.2915 11.8417C13.6864 11.2265 13.5032 10.7508 12.8075 10.3655C12.4116 10.1491 11.6238 9.71954 10.8807 9.28498C10.4155 9.01683 9.90677 8.8268 9.39661 8.72328C8.98909 8.64017 8.58749 8.53331 8.17684 8.44567C7.96109 8.39545 7.69738 8.38857 7.51124 8.57263L7.21033 8.87354C7.06007 9.0238 6.93818 9.20096 6.80658 9.36498C6.54879 9.70499 6.21599 9.8326 5.78644 9.6136C4.88533 9.14441 4.06514 8.61012 3.31414 8.01853C2.86515 7.68256 2.42417 7.32894 2.01174 6.94097C1.59864 6.55229 1.20292 6.14555 0.830071 5.71452C0.575347 5.42294 0.372181 5.0731 0.221885 4.6861C-0.00409196 4.12372 0.061734 3.69811 0.399436 3.34909C0.558002 3.18389 0.69214 3.00894 0.844761 2.8273L1.14568 2.52638C1.32974 2.34232 1.50993 2.13501 1.76808 2.06333C1.97126 2.00901 2.18971 2.02559 2.3964 2.05912C2.79999 2.12363 3.23998 2.00901 3.53206 2.3407C3.53206 2.3407 4.10503 3.00615 4.39332 3.34532C4.70485 3.71018 4.98095 4.10496 5.3011 4.47934C5.42049 4.62287 5.55262 4.75544 5.6984 4.87563C6.12998 5.25125 5.98848 5.29263 6.42883 5.61025C6.42883 5.61025 7.07134 6.08679 7.43447 6.40902C7.43447 6.40902 7.62135 6.55611 7.80541 6.70255C8.11439 6.94333 8.31475 7.18185 8.5585 7.54003C8.8508 7.98038 8.66757 8.27869 8.22819 8.49118C7.82203 8.68244 7.39894 8.82372 6.98264 8.96343C6.6452 9.07621 6.33164 9.24727 6.00733 9.4004C5.71012 9.53797 5.43272 9.69267 5.15712 9.86014C4.86656 10.0383 4.51834 10.0573 4.25844 9.81652C4.13828 9.69714 4.02674 9.55956 3.90415 9.4305C3.51546 9.00856 3.08279 8.60856 2.66895 8.19574C2.22502 7.75156 1.82342 7.25929 1.40492 6.77482C1.00363 6.30701 0.62117 5.82348 0.23417 5.34004C-0.00335434 5.04906 -0.0651168 4.67199 0.162219 4.34384C0.332275 4.10152 0.524869 3.87434 0.734063 3.65778C0.97219 3.41002 1.18138 3.15573 1.47795 3.03457C1.77516 2.91272 2.1126 2.95987 2.40358 3.0518C2.62143 3.1184 2.81268 3.2543 3.0155 3.35729L5.53413 2.45237Z"
                    stroke="#DBB079"
                  />
                </svg>
                (512) 596-3141
              </a>

              <a
                className="inline-flex items-center gap-x-4 text-white text-xs font-medium leading-8 transition-all duration-300 lg:justify-start justify-center"
                href="#"
              >
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M2 1.6H14C14.22 1.6 14.4 1.78 14.4 2V14C14.4 14.22 14.22 14.4 14 14.4H2C1.78 14.4 1.6 14.22 1.6 14V2C1.6 1.78 1.78 1.6 2 1.6ZM13.6 2.4H2.4V3.84L8 7.48L13.6 3.84V2.4ZM13.6 4.64L8 8.28L2.4 4.64V13.6H13.6V4.64Z"
                    fill="#DBB079"
                  />
                </svg>
                info@example.com
              </a>
            </div>
          </div>

          <div className="col-span-full lg:col-span-1 lg:text-left text-center">
            <h4 className="font-bold text-white uppercase">COMPANY</h4>
            <div className="mt-6 grid space-y-3">
              <p>
                <a className="inline-flex gap-x-2 text-xs text-white font-medium transition-all duration-300" href="#">
                  Privacy Policy
                </a>
              </p>
              <p>
                <a className="inline-flex gap-x-2 text-xs text-white font-medium transition-all duration-300" href="#">
                  Terms of Service
                </a>
              </p>
              <p>
                <a className="inline-flex gap-x-2 text-xs text-white font-medium transition-all duration-300" href="#">
                  Disclaimer
                </a>
              </p>
              <p>
                <a className="inline-flex gap-x-2 text-xs text-white font-medium transition-all duration-300" href="#">
                  Cookie Policy
                </a>
              </p>
              <p>
                <a className="inline-flex gap-x-2 text-xs text-white font-medium transition-all duration-300" href="#">
                  Contact Us
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
